<template>
    <div>
        <div class="row">
            <div class="col">
                <fuel-discounts-mutations-filter @getDiscountMutations="getDiscountMutations"   :products="products"
                                                       :stations="stations" />
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col">
                <fuel-discounts-mutations-table
                    ref="discountsTable"
                    :isLoaded="isLoaded"
                    :isLoading="isLoading"
                    :selectedProducts="selectedProducts"
                    :selectedStations="selectedStations"
                    :startDate="startDate"
                    @updateLoaded="updateLoaded"
                    :discountMutationsPerStation="discountMutationsPerStation"
                />
            </div>
        </div>
    </div>
</template>

<script>


export default {
    props: {
        products: Array,
        stations: Array,
    },
    data() {
        return {
            isLoading: false,
            isLoaded: true,
            messages: [],
            postSuccessful: null,
            selectedProducts:[],
            selectedStations:[],
            startDate:null,
            discountMutationsPerStation: {},
        };
    },
    methods: {
        updateLoaded: function (status ) {
            this.isLoading = status;
        },
        getDiscountMutations: function ({selectedProducts,selectedStations,startDate} ) {
            this.selectedProducts = selectedProducts;
            this.selectedStations = selectedStations;
            this.startDate = startDate;
            this.isLoading = true;
            this.$nextTick(() => {this.$refs.discountsTable.reloadTable()})
        },
    }

}
</script>
